import React from 'react';
import theme from '@/style';
import animationjson from './luckyspin-win-animation-config-web';
import {cn} from '@/utils';

const LuckyspinWinAnimationWeb = (props: {className?: string}) => {
  const viewRef = React.useRef(null);
  const {className} = props;
  React.useEffect(() => {
    if (document && viewRef.current) {
      const lottie = require('lottie-web');
      const animation = lottie.loadAnimation({
        container: viewRef.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: animationjson,
      });
      return () => {
        animation.destroy();
      };
    }
  }, []);
  return (
    <div
      ref={viewRef}
      style={
        className
          ? {}
          : {
              height: theme.imageSize.m * 3,
              width: theme.imageSize.m * 3,
            }
      }
      className={cn(className)}
    />
  );
};

export default LuckyspinWinAnimationWeb;
